import usePermissions from "core/hooks/usePermissions";
import {  PermissionName } from "core/permissions/Permissions";
import { ReactElement, ReactNode } from "react"
import { useNavigate } from "react-router-dom";

export interface ProtectedRouteProps {
    permission: PermissionName,
    children: ReactNode
}

export default function ProtectedRoute({permission, children}:ProtectedRouteProps):ReactElement {
    const { hasPermission } = usePermissions();
    const navigate = useNavigate();

    if(!hasPermission(permission)) {
        navigate("/");
       }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (<>{children}</>);
}